import { startOfDay } from "date-fns"

const initState = {
    currentHomePage: {},
    currentHomePageBeforeNotificationTab: {},
    showNewHeader: false,
    showHome: true,
    showAdminLoginPage: false,
    orderPopUp: false,
    orderPopUpMsg1: null,
    orderPopUpMsg2: null,
    orderPopupError:false,
    popUpMessage: null,
    popUpShow: false,
    loaderPopUpShow: false,
    goHomeClick: false,
    openCheckin:false,
    openViewBill:false,
    openDemoCamera:false,
    DNDon:false,
    MURon:false,
    showDoorKeyGuide: false,
    guestPreferedLang: null,
    guestDeviceLang: null,
    showLoader: false,
    loaderMessage: null,
    showSuccessFailPopUp: false,
    DigitalKeyRequestVerified: false,
    digitalKeySupportedAuthMethods: [],
    guestIsLoggedIn: false,
    multiSubWidget: {},
    guestIsCheckedIn: false,
    chatWidgetInnitialized: false,
    loaderClosed: false,
    selectedGuestName: null,
    mapOpened: false,
    checkinWidgetLaunchTime: "",
    checkinCurrentPageName: "",
    accompanyGuests: [],
    abortCheckinProcess:false,
    renderHomePage: false,
    enableCheckoutOnlyOnLastDate: false,
    showBookmarkPopup: false,
    afterLoginHotelSelectionState: {
        showPopup: false,
        hotelData: {}
    },
    loginGuestDetails: null,
    notificationMessage: "",
    showNotificationBox: false,
    galleryAppData: null,
    takeWebPicture : false,
    showAdhoc: false,
    adhocData: null,
    showValidationOption : false,
    openSMSWidgetBool: false,
    openProfileImage: false,
    featureNotAvailOnWeb: {
        enablePopup: false,
        featureName: ""
    },
    mobileDeepLink: "",
    externalSignIn: {
            responseReceivedFromHostedScript:"",
            validateAccountResponse:{},
            memberId:"",
            code:"",
            accessToken:"",
            shouldMarkAccountLinkedManually:false,
            jwtIdToken:""
    },
    makeUserLoginViaFindReservation:false,
    sideNavBar: {
        exploreItems: [],
        mystayItems: [],
        widgetList: [],
        currentWidgetList: [],
        deviceConfifApiCall: false,
    },

    checkinCard: {
        cardStatus: false,
        statusTitle: "",
        statusMessage1: "",
        statusMessage2: ""
      },

    cardChecksData: {
        cardValidationEnabled: true,
        cardNumberOfDigits: 4,
        allowEditScannedDetails: true,
        editableFieldList: [
            "lastName",
            "cardNumber"
        ],
        cardTokenRequired: false
    },
    preCheckInBookingDueIn: false,
    confirmaionPopUp: {
        showPopUP: false,
        popUpResponse: null,
        popUpcallFrom: null,
        msgToShow: null
    },
    doorKey: {
        showDoorKeyPage: false
    },
    selectedList: [],
    viewBill: {
        confirmPop: false,
        selectedGuest: {},
        showSucFailPop: false,
        sucFailPopStatus: false,
        sucFailMessage: ""
    },
    TVControl: {
        showLogin: false
    },
    roomControl: {
        currentPage: null
    },
    guest_itinerary: {
        status: "PENDING",
        errorMessage: "",
        payload: []
    },
    location_data: {
        status: "PENDING",
        payload: []
    },
    show_itineray_details: {
        status: false,
        itineraryData: {}
    },
    idCardImage:null,
    idCardImageBack:null,
    selfieVideo:null,
    idCardResponse: null,
    idCardBackResponse: null,
    selfieResponse: null,
    auto_checked_in: false,
    booking_ref:null,
    locationLink:null,
    mapSnapshot : null,
    id_rotate_deg:0,
    showDoorKeyPopup:true,
    hcommerceWidget:{},
    guestBooking:{
        allergyOptions : [],
        countryOptions : []
    },
    selectedIdType: null,
    openRoomDoor:false,
    showPlaceOrder: false,
    showDoorKeyLocationErr:false,
    deviceConfigFailed:false,
    serviceUnavailable:false,
    storeSku: null,
    callKeyclick: false,
    showAutoLoginPopup: {
        isVisible: false,
        autoLoginData: {}
    },
    queuedCheckInSuccess: false,
    queuedCheckInRoomNumber: null,
    checkPreCheckInWidgetState: "mobile check-in",
    unreadMessageCountChat: 0,
    zingleOnInitiated: false,
    checkInAddress : {
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        postalCode: "",
        country: ""
    },
    redirectInfo : {},
    openExternalLinkInSameTab:false,
    permissionWhileDoorKeyInfo:{
        bluetoothWarnCount:0,
        internetWarnCount:0
    }
}
export default (state = initState, action) => {
    switch (action.type) {
        case 'Set_Current_Home_Page':
            return {
                ...state, currentHomePage: action.payload
            }
        case "Set_Current_Home_Page_Before_Notification_Tab":
            return {
                ...state, currentHomePageBeforeNotificationTab: action.payload
            }
        case 'Set_Admin_Login_Page':
            return {
                ...state, showAdminLoginPage: action.payload
            }
        case 'Set_Guest_Device_Lang':
            return {
                ...state, guestDeviceLang: action.payload
            }
        //----------------Home Page--------------------------
        case 'Set_Nav_Item_List':
            return {
                ...state, sideNavBar: {
                    ...state.sideNavBar,
                    widgetList: action.payload
                }
            }
        case 'Set_Card_Status_Popup_Props':
            return {
                ...state, checkinCard: {
                ...state.checkinCard,
                cardStatus: action.payload.cardStatus,
                statusTitle: action.payload.statusTitle,
                statusMessage1: action.payload.statusMessage1,
                statusMessage2: action.payload.statusMessage2
                }
            }
        case 'Set_Card_Checks_Data':
            return{
                ...state, cardChecksData: action.payload
            }
        case 'Set_Guest_Prefered_Lang':
            return {
                ...state, guestPreferedLang: action.payload
            }
        
        case 'Set_Current_Tab_Nav_Item_List':
            return {
                ...state, sideNavBar: {
                    ...state.sideNavBar,
                    currentWidgetList: action.payload
                }
            }
            case 'Set_deviceConfifApiCall':
                return {
                    ...state, sideNavBar: {
                        ...state.sideNavBar,
                        deviceConfifApiCall: action.payload
                    }
                }
        case 'Set_open_room_door':
            return {
                ...state, openRoomDoor: action.payload
            }
        case 'Set_Hcommerce_Sku':
            return{
                ...state, storeSku: action.payload
            }
        
        case 'Set_device_config_failed':
            return{
                ...state,
                deviceConfigFailed:action.payload
            }

        case 'Set_Service_Unavailble':
            return{
                ...state,
                serviceUnavailable:action.payload
            }

        case 'Set_OpenDemoCamera':
            return {
                ...state,
                openDemoCamera: action.payload,

            }
       

        //--------------------confirm Page -------------------
        case 'Set_Confirmation_Page':
            return {
                ...state, confirmaionPopUp: {
                    ...state.confirmaionPopUp,
                    showPopUP: action.payload.status,
                    popUpcallFrom: action.payload.WhoCalled,
                    msgToShow: action.payload.message
                }
            }
        case 'Set_Loader':
            return{
                ...state,
                showLoader: action.payload.status,
                loaderMessage: action.payload.message,
                showLoaderClose: action.payload.showLoaderClose,
                loaderAdditionalHtmlClass: action.payload.loaderAdditionalHtmlClass
            }
        case 'Set_Loader_Closed':
            return{
                ...state, loaderClosed: action.payload
            }
        case 'Set_SuccessFailPopUp':
            return{
                ...state,
                showSuccessFailPopUp: action.payload
            }
        case 'Confirmation_Page_Response':
            return {
                ...state, confirmaionPopUp: {
                    ...state.confirmaionPopUp,
                    popUpResponse: action.payload
                }
            }
        case 'Set_Door_Notification_Page':
            return {
                ...state, doorKey: {
                    ...state.doorKey,
                    showDoorKeyPage: action.payload
                }
            }

        case 'Close_Order_PopUp':
            console.log("aaction", action.payload)
            return {
                ...state,
                orderPopUp: action.payload.status,
                orderPopUpMsg1: action.payload.msg1,
                orderPopUpMsg2: action.payload.msg2,
                orderPopupError: action.payload.error,
            }

        case 'Set_Selected_List':
            return {
                ...state, selectedList: action.payload
            }
        //--------------------------view Bill----------------------------------
        case 'Check_Out_Confirmation':
            return {
                ...state, viewBill: {
                    ...state.viewBill,
                    confirmPop: action.payload,

                }
            }
        case 'Set_Selected_Guest':
            return {
                ...state, viewBill: {
                    ...state.viewBill,
                    selectedGuest: action.payload,

                }
            }

        case 'Set_Success_Fail_Pop_UP':
            return {
                ...state, viewBill: {
                    ...state.viewBill,
                    showSucFailPop: action.payload.show,
                    sucFailPopStatus: action.payload.status,
                    sucFailMessage: action.payload.message
                }
            }

        case 'Set_Ppo_Up':
            return {
                ...state,
                popUpMessage: action.payload.msg,
                popUpShow: action.payload.status
            }
        
            case 'Set_LoaderPpo_Up':
                return {
                    ...state,
                    loaderPopUpShow: action.payload
                }

        case 'Set_Go_Home':
            return {
                ...state,
                goHomeClick: action.payload,

            }

        case 'Set_OpenCheckin':
            return {
                    ...state,
                    openCheckin: action.payload,
    
            }
        case 'Set_OpenViewBill':
            return {
                ...state,
                openViewBill: action.payload,

            }
        //-----------------------------tv control------------------
        case 'Set_TV_Login_Page':
            return {
                ...state, TVControl: {
                    ...state.TVControl,
                    showLogin: action.payload
                }
            }
        //-----------------------------room control ---------------    
        case 'Set_Room_Control_Page':
            return {
                ...state, roomControl: {
                    ...state.roomControl,
                    currentPage: action.payload
                }
            }
        case 'Set_Nav_Item_Explore':
            return {
                ...state, sideNavBar: {
                    ...state.sideNavBar,
                    exploreItems: action.payload
                }
            }
        case 'Set_Nav_Item_Mystay':
            return {
                ...state, sideNavBar: {
                    ...state.sideNavBar,
                    mystayItems: action.payload
                }
            }

        //---------------------auto Check-in------------------------
        case 'Set_id_image':
            return{
                ...state,
                idCardImage: action.payload
            }
        
        case 'Set_id_image_back':
            return{
                ...state,
                idCardImageBack: action.payload
            }
        case 'Set_Selected_Id_Type':
            return{
                ...state,
                selectedIdType: action.payload
            }
        case 'Set_selfie_image':
            return{
                ...state,
                selfieVideo: action.payload
            }
        
        case 'Set_id_resp':
            return {
                ...state,
                idCardResponse: action.payload
            }
        
        case 'Set_id_back_resp':
            return {
                ...state,
                idCardBackResponse: action.payload
            }
        case 'Set_selfie_resp':
            return {
                ...state,
                selfieResponse: action.payload
            }

        case 'Set_auto_checkedin':
            return{
                ...state,
                auto_checked_in: action.payload
            }

        case 'Set_booking_ref':
            return{
                ...state,
                booking_ref: action.payload
            }
        
        case 'Set_checkin_room_no':
            return{
                ...state,
                checkin_room_no: action.payload
            }

        case "Set_allergy_options":
            return{
                ...state,
                guestBooking : {
                    ...state.guestBooking,
                    allergyOptions : action.payload
                }
            }

        case "Set_country_options":
            return{
                ...state,
                guestBooking : {
                    ...state.guestBooking,
                    countryOptions : action.payload
                }
            }
        //----------------------H-Commerce2-------------------------------

        case "Set_Custom_Location":
            return {
                ...state,
                locationLink: action.payload
            }

        case "Set_map_snapshot":
            return {
                ...state,
                mapSnapshot: action.payload
            }

        case 'Set_id_rotate_deg':
            return{
                ...state,
                id_rotate_deg: action.payload
            }

        case 'Set_show_door_key_popup':
            return{
                ...state,
                showDoorKeyPopup:action.payload
            }
            
        case 'Set_hcommerce_widget':
            return{
                ...state,
                hcommerceWidget:action.payload
            }

        case "Set_show_place_order":
            return{
                ...state,
                showPlaceOrder:action.payload
            }
        case "Set_New_Header":
            return{
                ...state,
                showNewHeader: action.payload
            }
        case 'Set_DigiTal_Key_Verified':
            return{
                ...state,
                DigitalKeyRequestVerified: action.payload
            }
        case "Set_DigiTal_Key_Supported_Auth_Methods":
            return{
                ...state,
                digitalKeySupportedAuthMethods: action.payload
            }
        case "Set_User_Login":
            return{
                ...state,
                guestIsLoggedIn: action.payload
            }
        case "SET_MULTI_SUB_WIDGET":
            return{
                ...state,
                multiSubWidget: action.payload
            }
        case "Set_User_Checkin":
            return{
                ...state,
                guestIsCheckedIn: action.payload
            }
        case 'Set_Checkin_Widget_Launch_Time':
            return{
                ...state,
                checkinWidgetLaunchTime: action.payload
            }
        case 'Set_Chat_Widget_Innitialized':
            return{
                ...state,
                chatWidgetInnitialized: action.payload
            }

        case 'Set_Checkin_Current_PageName':
            return{
                ...state,
                checkinCurrentPageName: action.payload
            }

        case 'Set_Current_Logged_In_Guest_Details':
            return{
                ...state,
                loginGuestDetails: action.payload
            }
        
        case 'Set_AccompanyGuest_Data':
            return{
                ...state,
                accompanyGuests: action.payload
            }
        case 'Set_Abort_Checkin_process':
            return{
                ...state,
                abortCheckinProcess: action.payload
            }
        case "PRE_CHECKIN_BOOKING_STATE": 
            return {
                ...state,
                preCheckInBookingDueIn: action.payload
            }
        case 'Set_Notification':
            return{
                ...state,
                showNotificationBox: action.payload.showNotificationBox,
                notificationMessage: action.payload.notificationMessage
            }
        case "Gallery_App_Data":
            return{
                ...state,
                galleryAppData: action.payload
            }
        case "Set_Door_Key_Guide":
            return{
                ...state,
                showDoorKeyGuide: action.payload
            }
        case "Set_Selected_Guest_Name":
            return{
                ...state,
                selectedGuestName: action.payload
            }
        case "Set_Map_Opened":
            return{
                ...state,
                mapOpened: action.payload
            }
        case "Show_Validation_Option":
            return{
                ...state,
                showValidationOption : action.payload
            }
        case "Take_Web_Picture" : 
            return {
                ...state,
                takeWebPicture : action.payload
            }
        case "Check_Pre_CheckIn_Widget_State" :
            return {
                ...state,
                checkPreCheckInWidgetState: action.payload
            }
        case "Set_Call_Key_Click":
            return{
                ...state,
                callKeyclick : action.payload
            }
        case "Open_SMS_Widget": 
            return {
                ...state,
                openSMSWidgetBool: action.payload
            }
        case "Show_Bookmark_Popup": 
            return {
                ...state,
                showBookmarkPopup: action.payload
            }
        case "Enable_Checkout_Only_At_Last_Day":
            return {
                ...state,
                enableCheckoutOnlyOnLastDate: action.payload
            }
        case "HOTEL_SELECTION_AFTER_LOGIN":
            return {
                ...state,
                afterLoginHotelSelectionState: action.payload
            }
        case "RENDER_HOME_PAGE": 
            return  {
                ...state,
                renderHomePage: action.payload
            }
        case "Set_Open_Profile_Edit":
            return {
                ...state,
                openProfileImage: action.payload
            }
        case "Set_Feature_Not_Avail_Web":
            return {
                ...state,
                featureNotAvailOnWeb: {...state.featureNotAvailOnWeb, enablePopup: action.payload.enablePopup, featureName: action.payload.featureName || ""}
            }
        case "Set_Mobile_Deep_Link":
            return {
                ...state,
                mobileDeepLink: action.payload
            }
        case "Show_Adhoc": 
            return {
                ...state,
                showAdhoc: action.payload
            }
        case "Adhoc_Data":
            return {
                ...state,
                adhocData: action.payload
            }
        case "Queued_CheckIn_Success": {
            return {
                ...state,
                queuedCheckInSuccess: action.payload
            }
        }
        case "SHOW_AUTO_LOGIN_POPUP": {
            return {
                ...state,
                showAutoLoginPopup: {
                    isVisible: action.payload.status,
                    autoLoginData: action.payload.data
                },

            }
        }
        case "Queued_CheckIn_RoomNumber": {
            return {
                ...state,
                queuedCheckInRoomNumber: action.payload
            }
        }
        case "SET_CHECKIN_ADDRESS":
            return{
                ...state, checkInAddress: {
                    ...state.checkInAddress,
                    addressLine1: action.payload.addressLine1,
                    addressLine2: action.payload.addressLine2,
                    city: action.payload.city,
                    state: action.payload.state,
                    postalCode: action.payload.postalCode,
                    country: action.payload.country
                    }
            }
        case "Unread_Message_Count_Chat": 
            return {
                ...state,
                unreadMessageCountChat: action.payload
            }
        case "Zingle_on_Initiated":
            return {
                ...state,
                zingleOnInitiated: action.payload
            }
        case "SET_REDIRECTINFO":
            return{
                ...state, 
                redirectInfo: {
                    ...action.payload
                }

            }
        case "UPDATE_GUEST_ITINERARY_STATUS":
            return {
                ...state,
                guest_itinerary : {
                    ...state.guest_itinerary, 
                    ...action.payload
                }
            }
        case "UPDATE_LOCATION_DATA":
            return {
                ...state,
                location_data: {
                    ...state.location_data,
                    ...action.payload
                }
            }
        case "SHOW_GUEST_ITINERARY_DETAILS":
            return {
                ...state,
                show_itineray_details: {
                    ...state.show_itineray_details,
                    ...action.payload
                }
            }
        case "Set_Open_Link_In_Same_Tab":
            return {
                ...state, openExternalLinkInSameTab:action.payload
            }
             
        case "SET_EXTERNAL_SIGN_IN":
            console.log("SET_EXTERNAL_SIGN_IN", action.payload)
            return {
                ...state, externalSignIn:{...state.externalSignIn, ...action.payload}
            }
        case "SET_MAKE_USER_LOGIN_VIA_FIND_RESERVATION":
                console.log("SET_MAKE_USER_LOGIN_VIA_FIND_RESERVATION", action.payload)
                return {
                    ...state, makeUserLoginViaFindReservation: action.payload
                }
        case "Set_Permission_While_Door_Key_Info":
            return {
                ...state, permissionWhileDoorKeyInfo:{...state.permissionWhileDoorKeyInfo, ...action.payload}
            }
        default:
            return state;
    }
}